export default __webpack_public_path__ + "static/media/Res_Amazon-VPC_NAT-Gateway_48_Light.0ddf75e9.svg";